import React from 'react';
import Select from 'react-select';

const CustomSelect = ({
    value,
    name,
    options,
    handleChange,
    label,
    labelClassName,
    className,
    error,
    holder,
    ...props
}) => {
    const formattedOptions = options.map(opt => ({
        value: opt.id,
        label: opt.name,
    }));

    const selectedOption = formattedOptions.find(opt => opt.value === value) || null;

    const onChange = selected => {
        handleChange({
            target: {
                name,
                value: selected ? selected.value : '',
            },
        });
    };

    const ErrorMensaje = () => {
        if (error) {
            return <span className="text-fr-danger text-sm mt-1">{error}</span>;
        }
        return null;
    };

    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: error ? '#ef4444' : '#d1d5db',
            backgroundColor: props.disabled ? '#f4f5f5' : 'white',
            opacity: props.disabled ? 0.6 : 1,
            cursor: props.disabled ? 'not-allowed' : 'default',
            minHeight: '1rem',
            boxShadow: 'none',
            '&:hover': {
                borderColor: error ? '#ef4444' : '#3b82f6',
            },
        }),
    };

    return (
        <div className="flex flex-col w-full py-1 z-0">
            {label && <label className={`${labelClassName}`}>{label}</label>}
            <Select
                options={formattedOptions}
                value={selectedOption}
                onChange={onChange}
                isDisabled={props.disabled}
                placeholder={holder ?? 'Selecciona una opción'}
                name={name}
                styles={{
                    ...customStyles,
                    menuPortal: base => ({ ...base, zIndex: 9999 }) // <-- aquí la magia
                }}
                menuPortalTarget={document.body} // <-- renderiza el menú fuera del flujo del contenedor
                className={className}
                {...props}
            />

            <ErrorMensaje />
        </div>
    );
};

export default CustomSelect;
